import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import styles from "../../../../src/content/gospel-tv-spots/styles";
import "../../../../src/content/gospel-tv-spots/gospel-tv-prayer-line.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  styles,
  React
};